export default __webpack_public_path__ + "static/media/products.bdd29a6b.svg";